import React, { useState } from 'react';
import { MenuOutlined } from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
import { useNavigate } from 'react-router-dom';
import Sidebar from './sidebar';
import logo from '../images/nepal-government-logo.png';

const Header = () => {
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const navigate=useNavigate();

  const toggleSidebar = () => setSidebarVisible(!isSidebarVisible);
  const handleLogout = () => {
    // Clear authentication tokens or session data
    localStorage.removeItem('authToken'); // Example: Remove token from localStorage
    sessionStorage.clear(); // Example: Clear session storage if used

    // Redirect to login page or home
    navigate('/'); // Adjust the route as per your application
  };

  return (
    <>
      {/* Header */}
      <header className="flex justify-between items-center bg-gray-200 p-4 fixed top-0 left-0 w-full z-50 shadow-md">
        <div className="flex items-center">
          {/* Burger Button (Visible Only on Mobile) */}
          <MenuOutlined
            className="text-gray-700 text-xl cursor-pointer mr-4 lg:hidden" // `lg:hidden` hides on larger screens
            onClick={toggleSidebar}
          />
          <img src={logo} alt="Logo" className="h-10 mr-4" />
          <div>
            <h2 className="text-red-600 text-lg m-0">चन्द्रपुर नगरपालिका वडा ३</h2>
            <p className="text-red-600 text-sm m-0">रौतहट, मधेश प्रदेश, नेपाल</p>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          <Dropdown overlay={<Menu items={[{ key: 'logout', label: 'Log Out' ,onClick:handleLogout}]} />} trigger={['click']}>
            <img
              src="https://via.placeholder.com/40"
              alt="Profile"
              className="h-10 w-10 rounded-full cursor-pointer"
            />
          </Dropdown>
        </div>
      </header>

      {/* Sidebar (Mobile Only) */}
      {isSidebarVisible && (
        <Sidebar
          isMobile={true}
          toggleSidebar={toggleSidebar}
        />
      )}
    </>
  );
};

export default Header;
